import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveInvitationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RemoveInvitationMutation = { __typename?: 'Mutation', removeInvite: { __typename?: 'Invite', id: string } };


export const RemoveInvitationDocument = gql`
    mutation RemoveInvitation($id: ID!) {
  removeInvite(data: {id: $id}) {
    id
  }
}
    `;
export type RemoveInvitationMutationFn = Apollo.MutationFunction<RemoveInvitationMutation, RemoveInvitationMutationVariables>;

/**
 * __useRemoveInvitationMutation__
 *
 * To run a mutation, you first call `useRemoveInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvitationMutation, { data, loading, error }] = useRemoveInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvitationMutation, RemoveInvitationMutationVariables>(RemoveInvitationDocument, options);
      }
export type RemoveInvitationMutationHookResult = ReturnType<typeof useRemoveInvitationMutation>;
export type RemoveInvitationMutationResult = Apollo.MutationResult<RemoveInvitationMutation>;
export type RemoveInvitationMutationOptions = Apollo.BaseMutationOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>;